import Vue from 'vue'
import loadMore from '@/directive/load-more'

Vue.use(loadMore)
